import EventBus from "@packages/event-bus";

export default {
    data() {
        return {
            loadOnFilters: true
        };
    },

    watch: {
        filters() {
            if (this.loadOnFilters) {
                this.loadData();
            }
        }
    },

    methods: {
        loadData() {
            if (this.page) {
                this.goToFirstPageHandler();
            }
            this.load();
        }
    },

    mounted() {
        EventBus.$on("LOAD_DATA", this.loadData);
    },

    beforeDestroy() {
        EventBus.$off("LOAD_DATA", this.loadData);
    }
};
